<template>
  <table class="table-box">
    <slot></slot>
  </table>
</template>

<script>
import TableRow from './TableRow'

export default {
  components: {TableRow},
  name: 'table-box'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.table-box {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
  border: 1px solid $secondary;
  @include mq-down(md){
    border-bottom: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/tables/TableBox.vue